"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _admin = require("../../../../selectors/admin.js");
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var roles = window.cccisd.appDefs.pawn.roles;
var OtherAllowedRoles = function OtherAllowedRoles(_ref) {
  var fields = _ref.fields,
    isNew = _ref.isNew;
  var otherAllowedRoles = fields.otherAllowedRoles,
    respondentConfig = fields.respondentConfig,
    respondentSelection = fields.respondentSelection;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var projectDeployments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectDeployments)(state.assignment.admin);
  });
  var intendedRoleHandle = currentRoleType();
  var isAnon = respondentConfig.value === 'anonymous';
  var isKnown = respondentConfig.value === 'manual' || intendedRoleHandle === 'respondent' && respondentConfig.value === 'previous';

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE METHODS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function ensureCurrentRoleNotInList() {
      if (!isNew) {
        return;
      }
      otherAllowedRoles.onChange(otherAllowedRoles.value.filter(function (r) {
        return r !== intendedRoleHandle && r !== 'respondent';
      }));
    }
    ensureCurrentRoleNotInList();
  }, [intendedRoleHandle]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function currentRoleType() {
    var chosenDeployment = null;
    switch (respondentConfig.value) {
      case 'managed':
        return respondentSelection.value;
      case 'previous':
        chosenDeployment = projectDeployments.find(function (d) {
          return d.deploymentId === Number(respondentSelection.value);
        });
        return chosenDeployment && chosenDeployment.roleHandle || undefined;
      default:
        return 'respondent';
    }
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var renderCollapseArrow = /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_style["default"].collapseArrow, isCollapsed ? _style["default"].collapsed : _style["default"].expanded)
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
    spaceRight: true
  }));
  var renderCurrentRole = function renderCurrentRole() {
    var intendedRoleIsNumber = !Number.isNaN(Number.parseInt(intendedRoleHandle, 10));
    var selectedRole = roles.find(function (r) {
      return r.handle === intendedRoleHandle;
    });
    var selectedRoleLabel = selectedRole ? selectedRole.label : intendedRoleHandle;
    if (intendedRoleIsNumber) {
      selectedRoleLabel = '';
    } else if (isKnown) {
      selectedRoleLabel = 'Known Respondent';
    } else if (isAnon) {
      selectedRoleLabel = 'Anonymous Respondent';
    }
    var showDropdown = !isKnown && !isAnon;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      onClick: function onClick() {
        return showDropdown && setIsCollapsed(function (prev) {
          return !prev;
        });
      }
    }, showDropdown && renderCollapseArrow, /*#__PURE__*/_react["default"].createElement("strong", null, showDropdown && 'Intended ', "role:"), " ", selectedRoleLabel));
  };
  var renderAllowedRolesDropdown = function renderAllowedRolesDropdown() {
    if (isKnown || isCollapsed) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
      field: otherAllowedRoles,
      label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        label: "Other allowed roles",
        optional: true,
        tooltip: "Select any roles that should also be allowed to respond to this Data Collection Wave."
      })
    }, /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
      data: roles.filter(function (r) {
        return r.handle !== intendedRoleHandle && r.handle !== 'respondent';
      }),
      onChange: function onChange(e) {
        return otherAllowedRoles.onChange(e.map(function (r) {
          return r.handle;
        }));
      },
      placeholder: "--- Select other allowed roles ---",
      textField: function textField(item) {
        return item && item.label || '';
      },
      value: otherAllowedRoles.value,
      valueField: "handle"
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, renderCurrentRole(), renderAllowedRolesDropdown());
};
OtherAllowedRoles.propTypes = {
  fields: _propTypes["default"].object,
  isNew: _propTypes["default"].bool
};
var _default = exports["default"] = OtherAllowedRoles;